import { render, staticRenderFns } from "./Deactivated.vue?vue&type=template&id=6c3ed792&scoped=true&"
import script from "./Deactivated.vue?vue&type=script&lang=js&"
export * from "./Deactivated.vue?vue&type=script&lang=js&"
import style0 from "./Deactivated.vue?vue&type=style&index=0&id=6c3ed792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3ed792",
  null
  
)

export default component.exports